
/****************ELEMENTS*****************/
//this obj define, the actions realeted to each 
//th>table header and td

const timeDate = require ('../../../../../js-handler/time-date')


export const tableDetail = {
    entity: 'customercredit',//name table on the db
    dest: 'customercredit',//name of the entity on the system

    //action for body 
    //left click, directly to the fullcont 
    tdDataDetail:`data-detail='{ "click": [ {"dest":"ripple" },
                                            {"dest":"customercredit", "elem":"fullcont", "id":"customercredit-fullcont", "act":"selectOne", "entity":"customercredit", "dbid": "#dbid"}  ],
                                
                                 "clickRight": [{"dest":"customercredit", "elem":"dt", "act":"trMenu", "id":"trMenu",  "entity":"customercredit", "dbid": "#dbid" } ]  }'`,

    filter: {
        mainFilterFields : ["a.code","a.customer_name"],
        mainFilterValues : ["", ""],         
        andFilterFields  : [""],
        andFilterValues  : [""],  
    }

}



/****************ELEMENTS*****************/



//each element could organize their data diferent
export function organizeRow(data){ //console.log('organizeRow>')

    var newData = []

    if(data.length === 0){
        newData.push({   id: 'nothing', colum: [{ label:'No Results', span: ''},
                                                { label:'', span: '' },
                                                { label:'', span: '' },
                                                { label:'', span: '' }] })
        return newData
    }

    data.forEach((elem)=>{
        newData.push(
            {   id: elem.id,   colum: [  { label: elem.customer_name, span: elem.code,
                                            style:{ 
                                                tdClass:'tdWithAvatar',  
                                                avatar:elem.avatar,
                                                avatarColor: elem.avatarColor, 
                                                avatarColorLetter: elem.avatarColorLetter, 
                                                avatarLetter: elem.avatarLetter 
                                                
                                            } },  
                                         { label: elem.reference_number, span: ''},
                                         { label: elem.amount_dt, span: timeDate.friendlyDate(elem.date_td)},
                                         { label: elem.paid_invoices, span: elem.sales_code}]    
            }
        )/*push*/
    })/*forEach*/

    return newData
}/*organizeRow*/